import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { BookList } from './BookList';
import BookView from './BookView';

export const BookPage = ()=>{
    return (
        <Routes>
            <Route path="/" element={ <BookList /> } />
            <Route path="/:isbn/*" element={ <BookView /> } />
        </Routes>
    );
}